import { render, staticRenderFns } from "./PopUpForm.vue?vue&type=template&id=334e3854&scoped=true"
import script from "./PopUpForm.vue?vue&type=script&lang=js"
export * from "./PopUpForm.vue?vue&type=script&lang=js"
import style0 from "./PopUpForm.vue?vue&type=style&index=0&id=334e3854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334e3854",
  null
  
)

export default component.exports